module.exports = __webpack_public_path__ + "static/media/instagram.fbd1cfab.svg";